export default __webpack_public_path__ + "static/media/cakeBg.54844a94.jpg";